import { get } from "./restApi";

export const getHistoryByAsset = (id) => {
  return get(`qrCodeStickerHistory/get-by-asset/${id}`);
};
